import Model from './utils/model'
import nexus from '@db2b/nexus-js'

export default {
  ...Model,
  options: {
    translations: {
      name: 'Appel'
    },
    name: 'call',
    url: nexus.url('callcenter', 'calls')
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/call.js